import React, { useState } from "react";
import Modal from "react-modal";
import "../style/index.css";
import Loading from "../components/loading";
import Button from "../components/ui/button";
import check from "../assets/images/check.svg";
import Swal from "sweetalert2";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { acceptRepayment } from "../network/fetchers";
import { useNavigate } from "react-router";

const AcceptLoanRequest = (props) => {
  const [reason, setReason] = useState("");
  const navigate = useNavigate()

  const { mutateAsync: acceptRequest, isPending } = useMutation({
    mutationKey: ["acceptLoanRequest"],
    mutationFn: async () => await acceptRepayment({ reason, status: 'REPAID', id: props?.id, loanId: props?.loanId }),
    onSuccess: (res) => {
      if (res?.name === 'AxiosError' || res?.status === 400 || res?.response?.status === 400) {
        toast.error(res?.response?.data?.message || 'Error while approving request');
      } else {
        toast.success(res?.message || 'Request approved successfully');
      }
      props.setshow(false);
      navigate('/finance?payment-requests')
    },
    onError: (error) => {
      toast.error('Error while approving request');
      console.log(error);
      props.setshow(false);
    }
  })

  const closeModal = () => {
    props.setshow(false);
  };

  const handleDecline = async (e) => {
    e.preventDefault();
    if (props.onDecline) {
      props.onDecline(reason);
    } else {
      await acceptRequest()
    }

    closeModal();
  };

  const customStyles = {
    content: {
      margin: "5% auto",
      overflow: "hidden",
      maxWidth: "400px",
      height: "300px",
      width: "85%",
      padding: "20px",
      borderRadius: "8px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  const loaderToUse = props.loader ? props.loader : isPending

  return (
    <Modal
      isOpen={props.show}
      ariaHideApp={false}
      style={customStyles}
      contentLabel="Cancel Loan Modal"
    >
      <div className="modal-header">
        <span className="material-icons close-icon" onClick={closeModal}>
          close
        </span>
      </div>

      <div className="modal-content flex items-center justify-center flex-col">
        <img src={check} alt="check" className="mb-2" />
        <h3 className="w-[295px] text-[20px] text-[#101828] font-bold text-center mb-4">
          Are you sure you want to accept this payment request
        </h3>

        <form onSubmit={handleDecline} className="decline-form w-full">
          <Button
            className=" w-full mt-4 p-4 rounded-[10px] bg-[#EBE4FF] font-bold text-[#6F00FF] hover:bg-[#EBE4FF] hover:text-[[#6F00FF]"
            disabled={loaderToUse}
            // style={{
            //   background: props.loader === false && "rgb(111, 0, 255)",
            // }}
          >
            {loaderToUse ? <Loading /> : props?.loanId ? "Accept repayment" : "Accept request"}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default AcceptLoanRequest;
